import { Injectable } from '@angular/core';
import {
  Firestore
} from '@angular/fire/firestore';
import { FirestoreBase } from '../../core/db/firestore-base';
import { Wallet } from './wallet.models';

/**
 * Wallet Firestore data-access service.
 * Extends {@link FirestoreBase} to reuse generic CRUD and query helpers.
 * Use inherited methods such as `get$`, `getOneWhere$`, `create`, `upsert`, and `update`
 * from higher layers (`wallet.service`) unless a wallet-specific query is required.
 */
@Injectable({ providedIn: 'root' })
export class WalletDbService extends FirestoreBase<Wallet> {

  constructor(firestore: Firestore) {
    super(
      'wallets',
      firestore,
      { allowGetAll: true }
    );
  }
}
